export default "__VITE_ASSET__ajhDMHYI__"